var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocdoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 33,
    viewBox: "0 0 280 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.069 16.0304C184.069 9.7983 179.971 6.07644 173.825 6.04871C167.6 6.04871 163.582 10.1535 163.582 15.975C163.582 22.2348 167.679 25.9579 173.825 25.9579C180.052 25.9579 184.069 21.8481 184.069 16.0304ZM180.465 16.0027C180.465 20.0558 177.922 22.7865 173.853 22.7865V22.7827C169.482 22.755 167.187 19.7775 167.187 16.0027C167.187 11.9772 169.703 9.24665 173.8 9.21891C178.171 9.24665 180.465 12.2241 180.465 16.0027Z",
    fill: "#FF0D65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.505 16.0304C225.505 9.7983 221.408 6.07644 215.262 6.04871C209.035 6.04871 205.02 10.1535 205.018 15.975C205.018 22.2348 209.116 25.9579 215.262 25.9579C221.489 25.9579 225.505 21.8481 225.505 16.0304ZM221.902 16.0027C221.902 20.0558 219.359 22.7865 215.289 22.7865L215.29 22.7827C210.92 22.755 208.625 19.7775 208.624 16.0027C208.624 11.9772 211.139 9.24665 215.237 9.21891C219.607 9.24665 221.902 12.2241 221.902 16.0027Z",
    fill: "#FF0D65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.085 25.6506V6.34846H237.388C241.65 6.34846 243.835 7.94678 243.835 11.146C243.835 13.3514 242.961 14.8137 240.994 15.5858C243.343 15.9989 244.409 17.5154 244.409 20.0243C244.409 24.0233 241.568 25.6506 236.923 25.6506H229.085ZM236.897 14.5101C239.055 14.5101 240.42 13.5454 240.42 11.8903C240.42 10.3462 239.409 9.51866 236.979 9.51866H232.5V14.5101H236.897ZM237.146 22.4791C239.766 22.4791 240.97 21.6239 240.97 19.7762C240.97 17.9285 239.605 17.2118 237.201 17.2118H232.503V22.4791H237.146Z",
    fill: "#FF0D65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.297 12.3589H251.701V6.34846H248.288V25.6506H254.329C259.901 25.6506 262.906 23.3885 262.906 18.8945C262.906 14.5379 260.36 12.3589 254.297 12.3589ZM251.701 22.4791V15.5303H254.597C257.93 15.5303 259.377 16.4398 259.377 18.8114C259.377 21.4312 257.739 22.4791 254.542 22.4791H251.701Z",
    fill: "#FF0D65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.894 17.295H278.69L278.694 14.1235H269.898V9.51866H279.704V6.34846H266.479V25.6506H280V22.4791H269.894V17.295Z",
    fill: "#FF0D65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.057 19.6389V25.6506H187.642V6.34846H194.005C200.041 6.34846 202.614 8.52617 202.614 12.8828C202.614 17.3781 199.61 19.6389 194.005 19.6389H191.057ZM191.057 9.51866V16.4674H194.252C197.421 16.4674 199.059 15.4195 199.059 12.801C199.059 10.4293 197.64 9.51866 194.307 9.51866H191.057Z",
    fill: "#FF0D65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.215 22.4791C145.307 19.8593 146.099 16.2193 146.182 10.3462L146.236 6.34846H159.675V22.4791H161.887V29.2352H158.692V25.6506H145.334V29.2352H142.139V22.4791H144.215ZM147.548 22.4791H156.26V9.51866H149.351V10.4293C149.241 15.4749 148.636 19.4462 147.548 22.4791Z",
    fill: "#FF0D65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.305 6.07275C129.273 6.07275 127.061 6.98215 125.968 7.7819L125.965 12.5795C127.086 10.8702 129.408 9.18884 132.302 9.24296C134.324 9.29837 135.908 10.015 135.908 11.8073C135.908 13.2419 135.061 14.4272 132.603 14.4272H129.733V17.2674H132.629C135.606 17.2674 136.863 18.0672 136.863 19.7763C136.863 21.7349 135.006 22.7274 132.684 22.7551C129.159 22.7828 126.674 21.2387 125.5 19.2801V23.5272C126.516 24.6847 129.159 25.9543 132.629 25.9266C137.765 25.8989 140.414 23.3345 140.414 19.998C140.414 17.4601 138.997 15.9159 136.047 15.4751C138.26 14.6753 139.434 13.1865 139.434 10.9257C139.434 7.53381 136.593 6.10049 132.305 6.07275Z",
    fill: "#FF0D65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8523 22.1982C53.0938 22.2052 54.3169 21.8974 55.4082 21.3032L56.3211 20.807L58.9864 22.7781C57.2278 24.6681 54.6359 25.7068 51.6668 25.7068C48.8283 25.7068 46.234 24.6956 44.3783 22.8744C42.5225 21.0532 41.5 18.5221 41.5 15.7721C41.5 13.0222 42.5375 10.5285 44.3895 8.77237C46.2415 7.0162 48.8346 6.04871 51.6929 6.04871C54.3283 6.04871 56.6325 6.85245 58.3574 8.37364L58.553 8.5399L55.5987 10.7248C54.5071 9.94134 53.1942 9.52918 51.8523 9.54859C48.1396 9.54859 45.4444 12.2085 45.4444 15.8734C45.4444 19.5383 48.1396 22.1982 51.8523 22.1982Z",
    fill: "#21A038"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.608 13.762H66.5962V9.48463H74.5958L78.9077 6.29601H62.4774V25.4516H71.0712C75.8949 25.4516 78.661 23.258 78.661 19.4343C78.666 15.777 76.1589 13.762 71.608 13.762ZM70.8906 22.2617H66.5962V16.9519H70.8906C73.5061 16.9519 74.7216 17.8406 74.7216 19.6069C74.7216 21.4118 73.4276 22.2617 70.8906 22.2617Z",
    fill: "#21A038"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9321 6.29601L92.6203 9.48463H86.6196V14.1683H95.4163V17.3582H86.6196V22.2617H96.9321V25.4516H82.5008V6.29601H96.9321Z",
    fill: "#21A038"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.767 6.29601H108.625C113.638 6.29601 116.75 8.92215 116.75 13.1508C116.75 17.3794 113.635 20.0255 108.622 20.0255H104.886V25.4516H100.767V6.29601ZM104.886 16.8356H108.536C111.175 16.8356 112.627 15.5307 112.627 13.1608C112.627 10.7909 111.175 9.48463 108.536 9.48463H104.886V16.8356Z",
    fill: "#21A038"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4706 6.21826C29.2207 7.19473 29.8622 8.26169 30.3751 9.39902L15.8942 20.1465L9.84375 16.3273V11.7328L15.8942 15.5519L28.4706 6.21826Z",
    fill: "#21A038"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67171 16.0031C3.67171 15.797 3.67671 15.5922 3.68669 15.3886L0.019969 15.2039C0.00748866 15.469 0 15.7355 0 16.0031C0 20.4218 1.77845 24.4232 4.65516 27.3199L7.25482 24.7022C5.0433 22.4727 3.67171 19.3963 3.67171 16.0031Z",
    fill: "url(#paint0_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8938 3.69602C16.0985 3.69602 16.3019 3.70356 16.5041 3.71361L16.6876 0.020108C16.4242 0.00754079 16.1596 0 15.8938 0C11.5057 0 7.53199 1.79083 4.65527 4.68757L7.25493 7.30532C9.46894 5.0759 12.5241 3.69602 15.8938 3.69602Z",
    fill: "url(#paint1_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8934 28.3102C15.6887 28.3102 15.4853 28.3052 15.2831 28.2951L15.0996 31.9874C15.3629 31.9999 15.6275 32.0075 15.8934 32.0075C20.2814 32.0075 24.2552 30.2166 27.1319 27.3199L24.5322 24.7021C22.3182 26.9291 19.263 28.3102 15.8934 28.3102Z",
    fill: "url(#paint2_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7839 5.84375L25.8753 3.55024C23.1471 1.32961 19.6751 0 15.8936 0V3.69728C18.4483 3.69602 20.8208 4.49027 22.7839 5.84375Z",
    fill: "url(#paint3_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7865 16.0031C31.7865 15.0241 31.6991 14.0665 31.5319 13.1353L28.111 15.6738C28.1135 15.7832 28.116 15.8925 28.116 16.0018C28.116 19.6149 26.5609 22.8698 24.0898 25.1231L26.5572 27.8691C29.7684 24.9421 31.7865 20.7095 31.7865 16.0031Z",
    fill: "#21A038"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8936 28.3102C12.3055 28.3102 9.07308 26.7443 6.83535 24.256L4.1084 26.7405C7.01632 29.9753 11.2197 32.0074 15.8936 32.0074V28.3102Z",
    fill: "url(#paint4_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69787 6.8818L5.23051 4.13586C2.01807 7.06402 0 11.2967 0 16.0031H3.67171C3.67296 12.3888 5.22676 9.1351 7.69787 6.8818Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.39882,
    y1: 26.8564,
    x2: 1.33723,
    y2: 15.1973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1444,
    stopColor: "#F2E913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3037,
    stopColor: "#E7E518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5823,
    stopColor: "#CADB26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#A3CD39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 5.70463,
    y1: 5.34115,
    x2: 16.0549,
    y2: 1.42415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0592,
    stopColor: "#0FA8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5385,
    stopColor: "#0099F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    stopColor: "#0291EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.8573,
    y1: 29.7761,
    x2: 26.5491,
    y2: 27.1519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1226,
    stopColor: "#A3CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2846,
    stopColor: "#86C339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8693,
    stopColor: "#21A038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 15.1254,
    y1: 1.23836,
    x2: 25.1269,
    y2: 4.30293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0566,
    stopColor: "#0291EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C8ACB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 5.02935,
    y1: 26.2899,
    x2: 15.9214,
    y2: 30.3314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1324,
    stopColor: "#F2E913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2977,
    stopColor: "#EBE716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5306,
    stopColor: "#D9E01F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8023,
    stopColor: "#BBD62D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9829,
    stopColor: "#A3CD39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1.36842,
    y1: 16.4509,
    x2: 5.7862,
    y2: 5.03807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0698,
    stopColor: "#A3CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#81C55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9216,
    stopColor: "#0FA8E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocdoc);
export default __webpack_public_path__ + "static/media/docdoc.7c9d5b2d70eb26d1f243cdffc81d5b8d.svg";
export { ForwardRef as ReactComponent };